<template>
    <q-card @mouseleave="commitChanges()">
        <q-card-section>{{ item.headerName }}</q-card-section>
        <div class="q-px-sm q-py-xs">{{ Translate('Histogram Settings') }}</div>
        <q-separator></q-separator>
        <q-card-section>
            <q-input dense outlined hide-bottom-space
                          :label="Translate('Bucket Interval (sec)')"
                          type="number"
                          v-model="interval">
            </q-input>
            <q-checkbox v-if="false" dense hide-bottom-space v-model="ext">
                <template v-slot:label>
                    Extended Bounds
                    <q-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <q-icon class="ml-1" dense color="blue-grey lighten-4" v-bind="attrs" v-on="on">mdi-help-circle</q-icon>
                        </template>
                        {{ Translate('Extended bounds ensure the range you have selected is always included even if the data does not exist.') }}
                    </q-tooltip>
                </template>
            </q-checkbox>
            <div vstyle="display: flex; flex-direction: row;" v-if="false && ext">
                <q-input style="max-width:100px;" dense outlined hide-bottom-space :label="Translate('Min')" v-model="ext_min"></q-input>
                <q-input style="max-width:100px;" dense outlined hide-bottom-space :label="Translate('Max')" v-model="ext_max"></q-input>
            </div>
            <q-checkbox v-if="false" dense hide-bottom-space v-model="hard">
                <template v-slot:label>
                    Hard Bounds
                    <q-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <q-icon class="ml-1" dense color="blue-grey lighten-4" v-bind="attrs" v-on="on">mdi-help-circle</q-icon>
                        </template>
                        {{ Translate('Hard bounds limit the buckets to the specified minimum and maximum.') }}
                    </q-tooltip>
                </template>
            </q-checkbox>
            <div style="display: flex; flex-direction: row;" v-if="false && hard">
                <q-input style="max-width:100px;" dense outlined hide-bottom-space :label="Translate('Min')" v-model="hard_min"></q-input>
                <q-input style="max-width:100px;" dense outlined hide-bottom-space :label="Translate('Max')" v-model="hard_max"></q-input>
            </div>
        </q-card-section>
    </q-card>
</template>

<script>
    import methods from '@/Shared/methods';

    export default {
        data: function () {
            return {
                interval: 30,
                ext: false,
                ext_min: 0,
                ext_max: 300,
                hard: false,
                hard_min: 0,
                hard_max: 300,
            }
        },
        props: {
            item: Object,
            //menu_is_open: null,
        },
        created() {
            if (this.item.interval)
                this.interval = this.item.interval;

            if (this.item.extended_bounds) {
                this.ext = true;
                this.ext_min = this.item.extended_bounds.min;
                this.ext_max = this.item.extended_bounds.max;
            }

            if (this.item.hard_bounds) {
                this.hard = true;
                this.hard_min = this.item.hard_bounds.min;
                this.hard_min = this.item.hard_bounds.min;
            }
        },
        methods: {
            ...methods,
            commitChanges() {
                this.$emit('close');
                //this.menu_is_open = false;

                const newitem = {
                    colId: this.item.ColId,
                    interval: this.interval,
                };
                if (this.ext)
                    newitem.extended_bounds = {
                        min: this.ext_min,
                        max: this.ext_max,
                    };
                else
                    delete newitem.extended_bounds;

                if (this.hard)
                    newitem.hard_bounds = {
                        min: this.hard_min,
                        max: this.hard_max,
                    };
                else
                    delete newitem.hard_bounds;

                this.$emit('change', newitem);
            },
        }
    }
</script>

<style scoped>

</style>